import autocomplete from 'autocompleter';
import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import {disableElement, enableElement} from '@fretadao/f-js-dom';
import {isBlank} from '@fretadao/f-js-utils';

application.register(
  'populate-city-select',
  class extends Controller {
    static targets = ['cityField', 'stateField'];
    static values = { endpoint: String };

    connect() {
      this.wachStateChange();
    }

    wachStateChange() {
      this.stateFieldTarget.addEventListener('change', () => this.#populateCities());
    }

    async #getCities(stateAcrhonym) {
      if(isBlank(stateAcrhonym)) return new Promise((resolve) => resolve([]));

      const query = `${this.endpointValue}?state_acronym=${stateAcrhonym}`
      return fetch(query)
        .then(response => response.json())
        .catch(_error => alert('Estamos com problemas para carregar as cidades. Tente novamente mais tarde.'));
    }

    #populateCities() {
      this.#lockFields();
      const cityField = this.cityFieldTarget;

      this.#getCities(this.#selectedState())
        .then(cities => this.#addOptions(cityField, cities))
        .finally(() => this.#unlockFields());
    }

    #lockFields() {
      this.#fields().forEach(disableElement);
    }

    #unlockFields() {
      this.#fields().forEach(enableElement);
    }

    #fields() {
      return [this.stateFieldTarget, this.cityFieldTarget];
    }

    #removeOptions(field) {
      const startRemovingIndex = this.#fieldIncludeBlank(field) ? 1 : 0;

      while(field.options.length > startRemovingIndex) field.options.remove(startRemovingIndex);
    }

    #addOptions(field, options) {
      this.#removeOptions(field);
      options.forEach(option => {
        const optionTag = document.createElement('option')
        optionTag.value = option.id;
        optionTag.label = option.label;
        field.add(optionTag, null);
      });
    }

    #fieldIncludeBlank(field) {
      const firstOption = field.options[0];

      return [firstOption.value, firstOption.label].every(isBlank);
    }

    #selectedState() {
      const stateField = this.stateFieldTarget;
      const selectedOption = stateField.options[stateField.selectedIndex];

      return isBlank(selectedOption) ? null : selectedOption.value;
    }
  }
)
